import type { HTMLAttributes } from 'react'

import { cn } from './cn'

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Hauteur en classes Tailwind (ex. "h-4"). Défaut "h-4". */
  height?: string
  /** Largeur en classes Tailwind. Défaut "w-full". */
  width?: string
  /** Forme arrondie. Défaut "rounded-md". */
  shape?: 'rounded-sm' | 'rounded-md' | 'rounded-lg' | 'rounded-full'
}

export function Skeleton({
  height = 'h-4',
  width = 'w-full',
  shape = 'rounded-md',
  className,
  ...rest
}: SkeletonProps) {
  return (
    <div
      role="status"
      aria-label="Chargement"
      className={cn('animate-pulse bg-white/10', height, width, shape, className)}
      {...rest}
    />
  )
}

/** Lignes empilées — utile pour simuler un paragraphe. */
export function SkeletonLines({ count = 3 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} width={i === count - 1 ? 'w-2/3' : 'w-full'} />
      ))}
    </div>
  )
}
